import React from 'react'
import { NUMBER_OF_LESSONS } from '@mc/constants'
import {
  StyledFeatureVariable,
  PROMO_VARIABLE_NAMES,
} from '@mc/feature-variables'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { Pen5108TitleWrapper } from '../../experiments/pen-5108_v2_gift_page_experiment'
import { i18nInstance } from '../../i18n/i18nInstance'
import { PROMO_I18N_NAMESPACE, PROMO_FEATURE_FLAG } from '../../lib/constants'

const GiftHeroComp = () => {
  const { t } = useTranslation(PROMO_I18N_NAMESPACE)

  return (
    <>
      <Pen5108TitleWrapper
        control={
          <h1 className='mc-text-h1 mc-mb-2'>
            <StyledFeatureVariable
              flagName={PROMO_FEATURE_FLAG}
              variableName={PROMO_VARIABLE_NAMES.giftPageTitle}
              defaultCopy={t('common.gift.hero.title')}
            />
          </h1>
        }
      />
      <p className='mc-text-large mc-opacity--muted mc-mb-8'>
        <StyledFeatureVariable
          flagName={PROMO_FEATURE_FLAG}
          variableName={PROMO_VARIABLE_NAMES.giftPageSubtitle}
          defaultCopy={t('common.gift.hero.subtitle', {
            numberOfLessons: NUMBER_OF_LESSONS,
          })}
        />
      </p>
    </>
  )
}

export const GiftHero = withI18nContext(i18nInstance)(GiftHeroComp)
